import { Box, Skeleton, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

const SkeletonSubCategoryMobileRoot = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const SkeletonSubCategoryMobileLoader = styled(Skeleton)(({ theme }) => ({
  margin: theme.spacing(0, 3, 1, 6),
  paddingTop: theme.spacing(4),
}));

const TOPNAV_EXPANDED_HEIGHT_OFFSET = 200;
const SKELETON_HEIGHT = 60;

export const SkeletonSubCategoryMobile = () => {
  const elements = Math.floor((window.innerHeight - TOPNAV_EXPANDED_HEIGHT_OFFSET) / SKELETON_HEIGHT);
  const { getTestId } = useTestId();
  const steps = Array.from({ length: elements }, (element, index) => index);

  const skeletonElements = steps.map((step) => (
    <SkeletonSubCategoryMobileLoader
      key={`subcategory-desktop-${step}`}
      height={22}
      animation="wave"
      variant="rectangular"
    />
  ));

  return (
    <SkeletonSubCategoryMobileRoot data-testid={getTestId('skeleton-sub-category-mobile-root')}>
      {skeletonElements}
    </SkeletonSubCategoryMobileRoot>
  );
};
